import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { PasswordRecoveryPage } from "../../auth/password-recovery/password-recovery";


@Component({
  selector: 'page-configuration-password',
  templateUrl: 'configuration-password.html'
})

export class ConfigurationPasswordPage {

  constructor(public navCtrl: NavController,
    public globals: Globals) {
    this.globals.GAtrackView('Configuration', 'Configuration - Password - View', this.globals.restaurant.email, 'View', 'View recover password', 'Configuration', '');
  }

  openRecover() {
    //enviar peticio a firebase per enviar mail de canvi de contrasenya
    this.navCtrl.push(PasswordRecoveryPage, {
      'email': this.globals.user_email,
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-password/configuration-password.ts